export default "__VITE_ASSET__DawGITii__"